import React from 'react';
import {
  Box, createStyles, Text, Title, Grid,
} from '@mantine/core';
import { useTranslation } from 'react-i18next';
import {
  IconServer2, IconDeviceLaptop, IconDevices, IconSettings, IconBrandAmazon,
} from '@tabler/icons';

const useStyles = createStyles((theme) => ({
  generalBox: {
    marginBlock: theme.spacing.sm,
  },
}));

interface WorldlineTechnologiesProps {
  [x: string]: any,
}

export default function WorldlineTechnologies(
  { ...props }: WorldlineTechnologiesProps,
) {
  const { theme } = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'experience.content.professional.content.worldline.contents.technologies' });

  const backendItems = t('backend.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const frontendItems = t('frontend.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const awsItems = t('aws.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const nativeItems = t('native.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const otherItems = t('other.paragraphs', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  return (
    <Box {...props} sx={{ marginBottom: theme.spacing.md }}>
      <Title order={4} align="center" sx={{ padding: 0, marginBottom: theme.spacing.sm }}>
        {t('title')}
      </Title>
      <Grid justify="space-between" className="border-gradient" grow sx={{ paddingBlock: theme.spacing.sm }}>
        <Grid.Col xs={6} md={4} xl={2}>
          <Title order={5} align="left">
            {t('backend.title')}
            {' '}
            <IconServer2 />
          </Title>
          {backendItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={6} md={4} xl={2}>
          <Title order={5} align="left">
            {t('aws.title')}
            {' '}
            <IconBrandAmazon />
          </Title>
          {awsItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={6} md={4} xl={2}>
          <Title order={5} align="left">
            {t('frontend.title')}
            {' '}
            <IconDeviceLaptop />
          </Title>
          {frontendItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={6} md={4} xl={2}>
          <Title order={5} align="left">
            {t('native.title')}
            {' '}
            <IconDevices />
          </Title>
          {nativeItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
        <Grid.Col xs={6} md={4} xl={3}>
          <Title order={5} align="left">
            {t('other.title')}
            {' '}
            <IconSettings />
          </Title>
          {otherItems.map((item) => (
            <Text key={item} size="sm">{item}</Text>
          ))}
        </Grid.Col>
      </Grid>
    </Box>
  );
}
